import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SoundOnFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="soundOnFilled" ref={ref} {...props}>
    <path d="M11.33,7v9.9a.76.76,0,0,1-.41.67.81.81,0,0,1-.34.08.77.77,0,0,1-.44-.14L6.27,14.72H4.56A.76.76,0,0,1,3.81,14V10a.76.76,0,0,1,.75-.75H6.27l3.87-2.83A.75.75,0,0,1,11.33,7Zm2.84.21a.75.75,0,0,0-1,.3.73.73,0,0,0,.3,1,3.92,3.92,0,0,1,2,3.43v0a3.92,3.92,0,0,1-2,3.43.73.73,0,0,0-.3,1,.75.75,0,0,0,.66.39.8.8,0,0,0,.36-.09A5.4,5.4,0,0,0,17,12v0A5.4,5.4,0,0,0,14.17,7.25Zm1.13-3a.75.75,0,1,0-.65,1.35,7.11,7.11,0,0,1,0,12.82A.75.75,0,0,0,15,19.84a.79.79,0,0,0,.32-.08,8.6,8.6,0,0,0,0-15.52Z" />
  </Icon>
)) as IconWithRender;

SoundOnFilledIcon.displayName = 'SoundOnFilledIcon';
SoundOnFilledIcon.renderIcon = (props) => <SoundOnFilledIcon {...props} />;
export default SoundOnFilledIcon;
